import React,{useState, useRef, useEffect} from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {Link} from "react-router-dom";

const Container = styled.div`
    font-size: 12px;
`;


const Image = styled.div`
    background: url(${props => `https://image.tmdb.org/t/p/w500/${props.bgUrl}`});
    height: calc(27vw + 50px);
    background-size: cover;
    border-radius: 4px;
    background-position: center center;
    transition: 0.3s ease-in-out;
    `;

const Rating = styled.span`
    position: absolute;
    bottom: 10px;
    left:10px;
    opacity: 0;
    `;
const ImageContainer = styled.div`
            margin-bottom: 5px;
            position: relative;
            /* &:hover {
                opacity: 0.5;
            } */
            &:hover ${Image}{
                opacity: 0.5;
            }
            &:hover ${Rating}{
                opacity: 1;
            }
        `

const Title = styled.span`
    display: block;
    font-size: 12px;
    margin-bottom: 3px;

`;

const Year = styled.span`
    font-size: 10px;
    color: rgba(255,255,255,0.5);
    `;

const useStar = () => {
    const rating = useRef();
    
    let newRating = null;
    useEffect(() => {
        const val = rating.current.getAttribute('value');
        if(val === 0){
             newRating = "☆☆☆☆☆"; 
        } else if( val <= 2){
            newRating = "★☆☆☆☆"; 
        } else if( val <= 4){
            newRating = "★★☆☆☆"; 
        } else if( val <= 6){
            newRating = "★★★☆☆"; 
        } else if ( val <= 8){
            newRating = "★★★★☆"; 
        } else if ( val <= 10){
            newRating = "★★★★★"; 
        }
        rating.current.innerText = newRating;
    }, [])
    return rating;
}




const Poster = ({id, imageUrl, title, rating, year, isMovie = false}) => {
    
    const ra = useStar();
    return(
        <Link className="po" to={isMovie ? `/movie/${id}` : `/show/${id}`}>
        <Container>
            <ImageContainer>
                <Image bgUrl={imageUrl} />
                <Rating><span ref={ra} role="img" aria-label="rating" value={`${rating}`}>
                    {rating}
                    </span>
                    {rating} / 10
                </Rating>
            </ImageContainer>
            <Title>{title.length > 15 ? `${title.substring(0, 15)}...` : title}</Title>
            <Year>{year}</Year>
        </Container>
        </Link>
    )
}


Poster.propTypes = {
    id: PropTypes.number.isRequired,
    imageUrl: PropTypes.string,
    title: PropTypes.string.isRequired,
    rating: PropTypes.number,
    year: PropTypes.string,
    isMovie: PropTypes.bool.isRequired

}

export default Poster;